export const DEFAULT_STATE = {
  maintainId: "",
  customerName: "",
  saleCode: "",
  userCreate: "",
  claimId: "",
  createDate: "",
  customerCode: "",
  description: "",
  deviceId: "",
  deviceLotId: "",
  versionMachine: "",
  maintainStatusId: "",
  maintainStatus: "",
  maintainType: "",
  remaining: "",
  team: "",
  zone: "",
  remark: "",
  main_confirm_worker: "",
  main_confirm_start_date: "",
  main_endjob_name_tech: "",
  main_endjob_tech_start_date: "",
  main_endjob_tech_start_repair_date: "",
  main_endjob_tech_end_repair_date: "",
  main_endjob_remark: "",
  main_endjob_delivery: "",
  main_endjob_tech_service: "",
  main_endjob_tech_spare_part: "",
  main_endjob_tracking: "",
  main_endjob_damage: "",
  main_endjob_deviceId: "",
  deliverySale: {},
  spares: [],
  services: [],
  cause: {},
  deliveryProduct: {},
  linkVideo: "",
};
